import React from 'react';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#050810', position: 'relative' }}>
      <AdminSidebar />
      <main className="admin-layout-main" style={{
        flex: 1,
        padding: '16px 20px 80px',
        maxWidth: '100%',
        background: '#050810',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      }}>
        {children}
      </main>
    </div>
  );
}
